import styled from "styled-components";

export const Container = styled.div`
    width: 100%;
    max-width: 100vw;
    /* height: 100%; */
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 7.5rem;
    
    h1 {
        font-size: 35px;
        font-weight: 700;
        color: #495156;
    }
`;

export const Form = styled.form`
    margin-top: 48px;
    width: 440px;
    display: flex;
    flex-direction: column;

    .button-container {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 40px 0;
    }

    .control {
        margin-bottom: 32px !important;
    }

    button {
        width: 127px;
        height: 45px;
       
    }

    label {
        margin-bottom: unset;
        margin: unset;
        color: #495156;
        font-size: 1rem;
    }

    .info-container {
        display: flex;
        flex-direction: column;
        margin-top: 10px;

        span.info-name {
            font-weight: 400;
            font-size: 1rem;
            color: #495156;
            text-align: center;
        }
        
        .bold {
            font-weight: bold;
        }
    }
`;